export const FETCH_EMPLOYEE_ATTENDANCE_REQUEST = "FETCH_EMPLOYEE_ATTENDANCE_REQUEST";
export const FETCH_EMPLOYEE_ATTENDANCE_SUCCESS = "FETCH_EMPLOYEE_ATTENDANCE_SUCCESS";
export const FETCH_EMPLOYEE_ATTENDANCE_FAILURE = "FETCH_EMPLOYEE_ATTENDANCE_FAILURE";

export const FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_REQUEST = "FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_REQUEST";
export const FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_SUCCESS = "FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_SUCCESS";
export const FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_FAILURE = "FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_FAILURE";
